"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _tss = require("../styles/tss");
const useStyles = exports.useStyles = (0, _tss.makeTssStyles)({
  name: 'DsSeat',
  uniqId: 'eoiQuw'
})((theme, _params, classes) => {
  const {
    colors,
    spacing
  } = theme.busbud;
  return {
    sizeSm: {},
    petSeatPremium: {},
    petSeatRecline: {},
    petSeatStandard: {},
    top: {},
    paw: {},
    seatLabel: {},
    filler: {},
    root: {
      position: 'relative'
    },
    sizeLg: {
      [`&.${classes.left}`]: {
        [`> .${classes.petSeatRecline}`]: {
          position: 'absolute',
          transform: 'translateY(-50%)',
          left: spacing(-2),
          top: '50%'
        },
        [`> .${classes.petSeatPremium}`]: {
          transform: 'translateY(-50%)',
          position: 'absolute',
          left: spacing(-5),
          top: '50%'
        }
      },
      [`> .${classes.petSeatRecline}`]: {
        position: 'absolute',
        width: spacing(1),
        top: spacing(1.25)
      },
      [`> .${classes.petSeatPremium}`]: {
        position: 'absolute',
        width: spacing(5),
        top: spacing(2)
      }
    },
    sizeMd: {
      [`&.${classes.left}`]: {
        [`> .${classes.petSeatRecline}`]: {
          position: 'absolute',
          transform: 'translateY(-50%)',
          top: '50%',
          right: 0,
          margin: 0,
          left: spacing(0),
          width: spacing(3.5)
        },
        [`> .${classes.petSeatPremium}`]: {
          position: 'absolute',
          transform: 'translateY(-50%)',
          top: '50%',
          right: 0,
          margin: 0,
          left: spacing(0),
          width: spacing(5)
        }
      },
      [`> .${classes.petSeatRecline}`]: {
        position: 'absolute',
        width: spacing(5),
        top: spacing(0.75)
      },
      [`> .${classes.petSeatPremium}`]: {
        position: 'absolute',
        width: spacing(5),
        top: spacing(1.5)
      }
    },
    available: {
      cursor: 'pointer'
    },
    unavailable: {
      cursor: 'not-allowed'
    },
    selected: {
      color: colors.palette.green.regular[700]
    },
    unavailableMan: {
      color: colors.palette.blue.regular[800]
    },
    unavailableWoman: {
      color: colors.palette.red.regular[800]
    },
    standard: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: spacing(2.5),
      top: spacing(1),
      left: 0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      zIndex: 1
    },
    recline: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: spacing(2.5),
      top: spacing(1.5),
      left: 0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      zIndex: 1
    },
    premium: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: spacing(2.5),
      top: spacing(5.5),
      left: 0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      zIndex: 1
    },
    left: {
      [`& .${classes.seatLabel}`]: {
        transform: 'translateY(-50%)',
        top: '50%',
        [`&.${classes.premium}`]: {
          left: spacing(1.25)
        },
        [`&.${classes.recline}`]: {
          right: spacing(1.5)
        },
        [`&.${classes.standard}`]: {
          right: spacing(1)
        }
      }
    }
  };
});